import { useTranslate } from '@tolgee/react'
import { Breadcrumbs, Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { BreadcrumpItem } from 'modules/ui/src/theme/components/breadcrumbs/Breadcrumb'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router'

interface Props {
  inboundVisitName?: string | null
  outboundVisitName?: string | null
  containerNumber?: string | null
  containerId?: number
}
export const ContainerJourneyHistoryHeader = observer(
  ({ inboundVisitName, outboundVisitName, containerNumber, containerId }: Props) => {
    const { t } = useTranslate()
    const navigate = useNavigate()

    const title = t(`fromVisitToVisit`, '{inboundVisit} to {outboundVisit}', {
      inboundVisit: inboundVisitName ?? t('unknown', 'Unknown'),
      outboundVisit: outboundVisitName ?? t('unknown', 'Unknown'),
    })

    const breadCrumbs: BreadcrumpItem[] = computed(() => {
      return [
        { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
        {
          label: t(PATHS.masterData.containers.title),
          onClick: () => navigate(PATHS.masterData.containers.url),
        },
        {
          label: t('containerHistory', 'History - {containerNumber}', {
            containerNumber: containerNumber ?? '',
          }),
          onClick: () =>
            navigate(
              `${PATHS.masterData.containers.url}/${containerId}/${PATHS.masterData.containers.history.url}`,
            ),
        },
        {
          label: title,
        },
      ]
    }).get()

    return (
      <>
        <Helmet>
          <title>{t('containerJourneyHistory', 'TOM - Container Journey History')}</title>
        </Helmet>
        <Breadcrumbs items={breadCrumbs} />
        <Header title={title} />
      </>
    )
  },
)
